import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxButtonModule,
  DxTreeViewComponent,
  DxCheckBoxModule,
  DxDataGridModule,
  DxDataGridComponent,
  DxDateBoxModule,
  DxDropDownBoxModule,
  DxFormModule,
  DxNumberBoxModule,
  DxPopoverModule,
  DxPopupModule,
  DxProgressBarModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxToastModule,
  DxTreeListModule,
  DxTreeViewModule,
  DxValidatorModule,
  DxTagBoxModule,
} from 'devextreme-angular';
import { CommentsComponent } from 'src/app/components/comments/comments.component';
import { CommentService } from 'src/app/services/comment.service';
import { MicrotasksService } from 'src/app/services/microtasks.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppGlobals } from 'src/app/app.globals';
import { DataAccessService } from 'src/app/services/data-access.service';
import { TemplatesService } from 'src/app/services/templates.service';
import { PrioritiesConfig } from 'src/app/constants/Priority';
import { PriorityPillComponent } from 'src/app/components/priority-pill/priority-pill.component';
import { DeletePopupComponent } from '../../../../../components/delete-popup/delete-popup.component';
import { validateHeaderValue } from 'http';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/services/config.service';
import {
  TaskTypeEnum,
  TaskTypes,
  TaskType,
} from 'src/app/pages/config/project-config/project-structure-config/project-task-config/datatypes-taskconfig';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { FileViewerService } from 'src/app/services/file-viewer.service';
import { AppConfig } from 'src/app/app.config';
import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';

import { SearchableDropdownDirective } from '../../../../../directives/searchable-dropdown.directive';
interface TemplateFile {
  taskId: Number;
  file: File;
}

@Component({
    selector: 'app-project-microtasks',
    imports: [
        CommonModule,
        DxTextAreaModule,
        DxButtonModule,
        CommentsComponent,
        DxFormModule,
        DxDataGridModule,
        DxPopupModule,
        DxTreeListModule,
        DxSelectBoxModule,
        DxCheckBoxModule,
        DxProgressBarModule,
        DxDateBoxModule,
        DxTextBoxModule,
        DxDropDownBoxModule,
        DxNumberBoxModule,
        DxToastModule,
        DxTreeViewModule,
        DxValidatorModule,
        PriorityPillComponent,
        DeletePopupComponent,
        DxTagBoxModule,
        GpdButtonComponent,
        SearchableDropdownDirective,
    ],
    templateUrl: './project-microtasks.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./project-microtasks.page.css']
})
export class ProjectMicroTasksPage implements OnInit {
  documentFolderList: any[];

  projectId: number = null;

  type: any = '';
  message: any = '';
  toastVisible: boolean = false;

  isTreeBoxOpened: boolean = false;

  @ViewChild('microtasksDataGrid', { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild(DxTreeViewComponent, { static: false }) treeView;

  popupVisible: boolean = false;

  addTaskVisible: boolean = false;

  editTaskVisible: boolean = false;

  documentFolderVisible: boolean = false;
  userDefinedSelectionVisible: boolean = false;

  taskParentList: any = [];

  typeList: TaskType[];

  priorityList: any = PrioritiesConfig.map(x => x.value);

  treeDataSource: any = [];

  treeDataSourceSorted: any = [];

  isGridBoxOpened: boolean = false;
  gridBoxValue: any = '';
  commsDescrption: any = '';

  addMailMode: any = '';

  focusedSelectionId: any = '';

  saveTaskText: string = $localize`:@@saveMicrotasksCaps:SAVE MICROTASK`;

  editingData: any = {
    id: null,
    taskPackageId: null,
    title: null,
    type: null,
    priority: null,
    gridConnectionId: null,
    taskParentName: null,
    priorityName: null,
    documentFolderId: null,
    templateFilename: null,
    documentName: null,
    validationRequired: false,
    isUploaded: false,
  };

  departments = new Array();

  microTasks: any;

  microtasksDataGrid: any;

  removeTaskButtonOptions: any = {};

  deleteTaskText: string = $localize`:@@deleteMicrotasksCaps:DELETE MICROTASK`;
  editMode: boolean = false;
  deletePopupVisible: boolean = false;
  itemToDelete: any;
  priorityVisible: boolean = false;
  confirmText = $localize`:@@confirmCaps:CONFIRM`;
  cancelText = $localize`:@@cancelCaps:CANCEL`;

  taskPackages: any[];

  constructor(
    private commentService: CommentService,
    private templateService: TemplatesService,
    private dataAccessService: DataAccessService,
    private activatedRoute: ActivatedRoute,
    private microtasksService: MicrotasksService,
    private router: Router,
    private fileViewerService: FileViewerService,
    private configService: ConfigService,
    private appGlobals: AppGlobals,
    private activityLog: ActivityLogService
  ) {}

  ngOnInit(): void {
    this.projectId = parseInt(this.activatedRoute.snapshot.params.id);
    this.focusedSelectionId = parseInt(this.activatedRoute.snapshot.params.id);

    this.typeList = TaskTypes;

    if (isNaN(this.focusedSelectionId)) this.focusedSelectionId = 0;
    this.activityLog.logView({ Section: ActivitySection.PROJECT_MICRO_TASKS, ProjectId: this.projectId });
    this.getPageData();
  }

  async getPageData() {
    let payload = {
      ProjectId: this.projectId,
    };

    // Get project folders (including site folders)
    await this.microtasksService
      .getDocumentFolders({
        IncludeGridConnectionFolders: true,
        IncludeProjectFolders: true,
        ProjectId: this.projectId,
      })
      .then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.documentFolderList = [...result.folderList];
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );

    this.microtasksService.getMicroTasks(payload).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.microTasks = result.microTasks;
          this.taskParentList = result.parentTasks.tasks;
          //this.documentsList = result.documentLocations;
          for (let i = 0; i < this.microTasks.length; i++) {
            for (let p = 0; p < this.priorityList.length; p++) {
              if (this.microTasks[i].priority === this.priorityList[p].itemId) {
                this.microTasks[i].priorityName = this.priorityList[p].itemName;
              }
            }
          }
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );

    this.dataAccessService.getDepartments({}).then(result => {
      this.departments = result.departmentItems;
    });

    this.configService.getProjectConfiguration().then(result => {
      console.log(result);

      this.taskPackages = result.phases.flatMap(p => p.milestones.flatMap(m => m.taskPackages));
      console.log(this.taskPackages);
    });
  }

  addNewMicrotask(): void {
    this.dataGrid.instance.addRow();
    setTimeout(() => {
      let ds = this.dataGrid.instance.getVisibleRows()[0];
      ds[0].validationRequired = false;
    }, 500);
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    if ((this.type = 'success')) {
      this.message = e.feedback;
    } else {
      AppGlobals.ShowErrorMessage($localize`:@@errorTryAgain:ERROR: There was an error, please try again.`);
    }
    this.type = type;
    this.toastVisible = true;
  }

  getTaskTitleById(parentTaskId: any) {
    let i = this.taskParentList.find((task: any) => task.taskId == parentTaskId);
    return i ? i.taskName : '';
  }

  changeType(e: any): void {
    if (e.selectedItem.typeId === 3) {
      this.documentFolderVisible = true;
    } else {
      this.documentFolderVisible = false;
      this.editingData.documentFolderId = null;
    }
  }

  handleRowPrepared(e: any): void {
    // Bound to (onCellPrepared). Not every cell type carries both elements, and an
    // unguarded dereference here throws once per cell, filling the console on every
    // grid render. Observed on the dev site as
    // "TypeError: Cannot read properties of undefined (reading 'style')".
    e.element?.style.setProperty('cursor', 'pointer');
    e.cellElement?.style.setProperty('cursor', 'pointer');
  }

  toggleEditMode(arg0: boolean) {
    this.editMode = arg0;
  }

  addRow($event: any) {
    this.dataGrid.instance.addRow();
  }

  editMicroTask(arg0: any) {
    this.dataGrid.instance.editRow(arg0.rowIndex);
  }

  initDeleteMicrotask(arg0: any) {
    this.itemToDelete = arg0;
    this.deletePopupVisible = true;
  }

  deleteMicroTask($event: any) {
    if (this.itemToDelete.id < 0) {
      let index = this.microTasks.findIndex((x: any) => x.taskId === this.itemToDelete.id);
      this.microTasks.splice(index, 1);
      this.deletePopupVisible = false;
    } else {
      this.microtasksService.deleteMicroTask({ TaskId: this.itemToDelete.id }).then(result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          // let index = this.microTasks.findIndex((x: any) => x.taskId === this.itemToDelete.id);
          // this.microTasks.splice(index, 1);
          this.getPageData();
          this.dataGrid.instance.refresh();
          this.deletePopupVisible = false;
          this.saveToast({ type: 'success', feedback: $localize`:@@deleted:Deleted` });
        }
      });
    }
  }
  editData: any = {};
  fileTemplate: string = '';
  async saveChanges(event: any) {
    let url = this.router.url;
    let splitUrl = url.split('/');
    let gridId = splitUrl[2];

    this.editingData.gridId = gridId;
    let taskChanged = this.editData;
    if (taskChanged == null) return;
    if (taskChanged.id == '') taskChanged.id = null;

    let fileTaskId = '0';
    if (taskChanged.id != null) fileTaskId = '' + taskChanged.id;

    let editedTask = [];

    editedTask.push(this.editingData);

    this.microtasksService.saveMicroTasks({ MicroTasks: editedTask, ProjectId: this.projectId }).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else {
          this.saveToast({ type: 'success', feedback: $localize`:@@saved:Saved` });
          this.onEditCanceling();
          this.getPageData();
          this.dataGrid.instance.refresh();

          var formData = new FormData();
          formData.append('taskId', result.taskId);
          formData.append('filename', this.editingData.templateFilename);
          formData.append('fileType', this.templateFile.file.type);
          formData.append('fileBytes', this.templateFile.file);

          this.templateService.uploadMicroTaskTemplateFile(formData).then(
            resultb => {
              if (resultb.hasError === true) AppGlobals.ShowErrorMessage(resultb.feedback);
              else {
                this.saveToast({ type: 'success', feedback: $localize`:@@fileUploaded:File Uploaded` });
                this.fileTemplate = resultb.templateFileUploadResultItem.filename;
                this.onEditCanceling();
                this.getPageData();
                this.dataGrid.instance.refresh();
              }
            },
            (errorb: any) => {
              AppGlobals.ShowErrorMessage(errorb);
            }
          );
        }
      },
      (error: any) => {
        AppGlobals.ShowErrorMessage(error);
      }
    );
  }

  onTypeValueChanged(e: any, item: any) {
    item.editorOptions.value = e.value;
    this.editingData.type = e.value;

    if (e.value == 'document') {
      this.documentFolderVisible = true;
    } else {
      this.documentFolderVisible = false;
    }
    if (e.value == 'user defined selection') {
      this.userDefinedSelectionVisible = true;
    } else {
      this.userDefinedSelectionVisible = false;
    }
    if (e.value == 'group') {
      this.priorityVisible = false;
    } else {
      this.priorityVisible = true;
    }

    //  this.dataGrid.instance.refresh();
  }

  clearEditingData(): void {
    this.editingData = {};
    this.editingData['id'] = null;
    this.editingData['taskPackageId'] = null;
    this.editingData['title'] = null;
    this.editingData['type'] = null;
    this.editingData['priority'] = null;
    this.editingData['documentFolderId'] = null;
    this.editingData['documentName'] = null;
    this.editingData['departmentId'] = null;
    this.editingData['templateFilename'] = null;
    this.editingData['validationRequired'] = false;
    this.editingData['userDefinedFields'] = null;
    this.editingData['isUploaded'] = false;
  }

  onTaskPackageValueChanged(e: any) {
    this.editingData.taskPackageId = e.value;
  }
  enableViewFile: boolean = true;
  onEditInit(e: any) {
    this.editingData = e.data;
    if (this.editingData.templateFilename != null) this.enableViewFile = false;
    if (e.data.type == 'document') {
      this.documentFolderVisible = true;
    } else {
      this.documentFolderVisible = false;
    }
    if (e.data.type == 'user defined selection') {
      this.userDefinedSelectionVisible = true;
    } else {
      this.userDefinedSelectionVisible = false;
    }
    if (e.data.type == 'group') {
      this.priorityVisible = false;
    } else {
      this.priorityVisible = true;
    }

    this.dataGrid.instance.refresh();
  }

  newId = 0;

  getNewId() {
    this.newId = this.newId - 1;
    return this.newId;
  }

  onRowAdded(e) {
    e.data['id'] = null;
    e.data['taskPackageId'] = null;
    e.data['title'] = null;
    e.data['type'] = null;
    e.data['priority'] = null;
    e.data['documentFolderId'] = null;
    e.data['documentName'] = null;
    e.data['templateFilename'] = null;
    e.data['departmentId'] = null;
    e.data['validationRequired'] = false;
    e.data['userDefinedFields'] = null;
    this.editingData['isUploaded'] = false;

    //  e.data = this.editingData;
    this.editingData = {};
    this.editingData = e.data;
  }

  changeValidation(e: any): any {
    if (e.validationRequired === undefined || e.validationRequired === null) {
      e.validationRequired = false;
    }
  }

  changeRequiresValidation(event: any, e: any): any {
    e.validationRequired = event.value;
  }

  viewFileText: any = $localize`view file: `;
  templateFiles = new Array<TemplateFile>();
  templateFile: any = {};
  onTemplateFileChanged(e, taskId) {
    const file = e.target.files[0];
    if (file) {
      if (file.name.length > AppConfig.MaxFileNameLength) {
        AppGlobals.ShowErrorMessage($localize`:@@fileNameTooLong:File name is too long`);
        e.target.value = '';
        return;
      }
      this.editingData.templateFilename = file.name;
      this.templateFile = {
        taskId: taskId.id,
        file: file,
        isUploaded: false,
      };
      this.enableViewFile = true;
      let task = this.microTasks.find(item => item.id == taskId.id);
      if (task == null) return;
      task.templateFilename = file.name;
      task.isUploaded = true;
    }
  }

  getTemplateFile(filename, taskData: any) {
    this.fileViewerService.openOrDownloadFile('micro-task', 0, filename, '');
  }

  downloadFileFromBase64(base64: string, fileName: string, fileType: string): void {
    const byteArray = this.base64ToArrayBuffer(base64);

    // Determine MIME type
    let mimeType = '';
    switch (fileType) {
      case 'png':
      case 'jpeg':
        mimeType = `image/${fileType}`;
        break;
      case 'csv':
      case 'txt':
        mimeType = `text/${fileType}`;
        break;
      case 'pdf':
      case 'json':
      case 'zip':
        mimeType = `application/${fileType}`;
        break;
      case 'xls':
        mimeType = `application/vnd.ms-excel`;
        break;
      case 'ppt':
        mimeType = `application/vnd.ms-powerpoint`;
        break;
      case 'odt':
        mimeType = `application/vnd.oasis.opendocument.text`;
        break;
      case 'pptx':
        mimeType = `application/vnd.openxmlformats-officedocument.presentationml.presentation`;
        break;
      case 'xlsx':
        mimeType = `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`;
        break;
      case 'docx':
        mimeType = `application/vnd.openxmlformats-officedocument.wordprocessingml.document`;
        break;
      default:
        mimeType = 'application/octet-stream';
    }

    const blob = new Blob([byteArray], { type: mimeType });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }

  deleteTemplateFile(taskId, templateFilename, taskData: any) {
    if (this.enableViewFile) {
      this.editingData.templateFilename = null;
    } else {
      this.templateService
        .deleteMicrotaskTemplateFile({ TemplateFileRequestItem: { TaskId: taskId, Filename: templateFilename } })
        .then(
          result => {
            if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
            else {
              this.saveToast({ type: 'success', feedback: $localize`Deleted` });
              this.microTasks.find(item => item.id == taskId).templateFilename = null;
            }
          },
          (error: any) => {
            AppGlobals.ShowErrorMessage(error);
          }
        );
    }
  }

  base64ToArrayBuffer(base64: string): ArrayBuffer {
    let binaryString = window.atob(base64);
    let len = binaryString.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  saveByteArray(reportName, fileType, byte) {
    let mimeType = '';

    switch (fileType) {
      case 'png':
      case 'jpeg':
        mimeType = `image/${fileType}`;
        break;
      case 'csv':
      case 'txt':
        mimeType = `text/${fileType}`;
        break;
      case 'pdf':
      case 'json':
      case 'zip':
        mimeType = `application/${fileType}`;
        break;
      case 'xls':
        mimeType = `application/vnd.ms-excel`;
        break;
      case 'ppt':
        mimeType = `application/vnd.ms-powerpoint`;
        break;
      case 'odt':
        mimeType = `application/vnd.oasis.opendocument.text`;
        break;
      case 'pptx':
        mimeType = `application/vnd.openxmlformats-officedocument.presentationml.presentation`;
        break;
      case 'xlsx':
        mimeType = `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`;
        break;
      case 'docx':
        mimeType = `application/vnd.openxmlformats-officedocument.wordprocessingml.document`;
        break;
      default:
        mimeType = 'application/octet-stream';
    }

    const blob = new Blob([byte], { type: mimeType });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = reportName;
    document.body.appendChild(link); // Required for Firefox
    link.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    }, 100);
  }

  onEditCanceling() {
    let editedRow;

    for (let row of this.dataGrid.instance.getVisibleRows()) {
      if (row.isEditing === true) {
        editedRow = row;
        break;
      }
    }
    this.dataGrid.instance.cancelEditData();
    this.getPageData();
    this.dataGrid.instance.refresh();
  }
}
